import React from 'react';
import { StarIcon, MessageCircleIcon, MailIcon, PhoneIcon } from 'lucide-react';
import { Button } from './Button';
export function TrustSection() {
  const reviews = [{
    id: 1,
    name: 'Sarah T.',
    country: 'United States',
    rating: 5,
    text: 'Perfect for my Europe trip! Setup was super easy and I had reliable connection throughout my vacation.',
    date: '2 weeks ago'
  }, {
    id: 2,
    name: 'James L.',
    country: 'Australia',
    rating: 5,
    text: 'Used this for my business trip to Japan. The connection was fast and stable. Will definitely use again!',
    date: '1 month ago'
  }, {
    id: 3,
    name: 'Maria G.',
    country: 'Spain',
    rating: 4,
    text: 'Good service overall. Had a minor issue but customer support resolved it quickly.',
    date: '2 months ago'
  }];
  const renderStars = (rating: number) => {
    return Array(5).fill(0).map((_, i) => <StarIcon key={i} className={`h-4 w-4 ${i < rating ? 'text-yellow-400 fill-yellow-400' : 'text-gray-300'}`} data-id="element-678" />);
  };
  return <section id="support" className="py-16 w-full bg-[#F9FAFB]" data-id="element-679">
      <div className="container mx-auto px-4" data-id="element-680">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12" data-id="element-681">
          {/* Trust badges and support */}
          <div data-id="element-682">
            <h2 className="text-3xl font-bold mb-6" data-id="element-683">
              Trusted by Travelers Worldwide
            </h2>
            {/* Payment methods */}
            <div className="mb-8" data-id="element-684">
              <h3 className="font-semibold text-lg mb-4" data-id="element-685">
                Secure Payment Methods
              </h3>
              <div className="flex flex-wrap gap-4" data-id="element-686">
                <div className="bg-white p-3 rounded-lg shadow-sm" data-id="element-687">
                  <img src="https://upload.wikimedia.org/wikipedia/commons/thumb/b/ba/Stripe_Logo%2C_revised_2016.svg/2560px-Stripe_Logo%2C_revised_2016.svg.png" alt="Stripe" className="h-8" data-id="element-688" />
                </div>
                <div className="bg-white p-3 rounded-lg shadow-sm" data-id="element-689">
                  <img src="https://upload.wikimedia.org/wikipedia/commons/thumb/b/b5/PayPal.svg/2560px-PayPal.svg.png" alt="PayPal" className="h-8" data-id="element-690" />
                </div>
                <div className="bg-white p-3 rounded-lg shadow-sm" data-id="element-691">
                  <img src="https://upload.wikimedia.org/wikipedia/commons/thumb/c/c7/Apple_Pay_logo.svg/1280px-Apple_Pay_logo.svg.png" alt="Apple Pay" className="h-8" data-id="element-692" />
                </div>
                <div className="bg-white p-3 rounded-lg shadow-sm" data-id="element-693">
                  <img src="https://upload.wikimedia.org/wikipedia/commons/thumb/f/f2/Google_Pay_Logo.svg/1280px-Google_Pay_Logo.svg.png" alt="Google Pay" className="h-8" data-id="element-694" />
                </div>
              </div>
            </div>
            {/* 24/7 Support */}
            <div className="mb-8" data-id="element-695">
              <h3 className="font-semibold text-lg mb-4" data-id="element-696">
                24/7 Customer Support
              </h3>
              <div className="bg-white p-6 rounded-xl shadow-sm" data-id="element-697">
                <p className="mb-6 text-gray-600" data-id="element-698">
                  Our support team is available 24/7 to assist you with any
                  questions or issues.
                </p>
                <div className="grid grid-cols-1 md:grid-cols-3 gap-4" data-id="element-699">
                  <div className="flex flex-col items-center p-4 border border-gray-100 rounded-lg hover:bg-blue-50 transition-colors" data-id="element-700">
                    <MessageCircleIcon className="h-6 w-6 text-[#2563EB] mb-2" data-id="element-701" />
                    <span className="text-sm font-medium" data-id="element-702">Live Chat</span>
                  </div>
                  <div className="flex flex-col items-center p-4 border border-gray-100 rounded-lg hover:bg-blue-50 transition-colors" data-id="element-703">
                    <MailIcon className="h-6 w-6 text-[#2563EB] mb-2" data-id="element-704" />
                    <span className="text-sm font-medium" data-id="element-705">Email Support</span>
                  </div>
                  <div className="flex flex-col items-center p-4 border border-gray-100 rounded-lg hover:bg-blue-50 transition-colors" data-id="element-706">
                    <PhoneIcon className="h-6 w-6 text-[#2563EB] mb-2" data-id="element-707" />
                    <span className="text-sm font-medium" data-id="element-708">Phone Support</span>
                  </div>
                </div>
              </div>
            </div>
            {/* Need help CTA */}
            <div className="bg-gradient-to-r from-[#2563EB] to-[#1D4ED8] rounded-xl p-6 text-white" data-id="element-709">
              <h3 className="font-semibold text-lg mb-2" data-id="element-710">Need Help?</h3>
              <p className="mb-4 text-blue-100" data-id="element-711">
                Our team is ready to assist you with any questions about our
                eSIM services.
              </p>
              <Button variant="primary" data-id="element-712">Contact Support</Button>
            </div>
          </div>
          {/* Customer reviews */}
          <div data-id="element-713">
            <div className="flex justify-between items-center mb-6" data-id="element-714">
              <h2 className="text-3xl font-bold" data-id="element-715">Customer Reviews</h2>
              <div className="flex items-center" data-id="element-716">
                <div className="flex mr-2" data-id="element-717">{renderStars(5)}</div>
                <span className="font-semibold" data-id="element-718">4.8/5</span>
              </div>
            </div>
            <div className="space-y-6" data-id="element-719">
              {reviews.map(review => <div key={review.id} className="bg-white p-6 rounded-xl shadow-sm" data-id="element-720">
                  <div className="flex justify-between mb-2" data-id="element-721">
                    <div data-id="element-722">
                      <h4 className="font-semibold" data-id="element-723">{review.name}</h4>
                      <p className="text-sm text-gray-500" data-id="element-724">{review.country}</p>
                    </div>
                    <span className="text-sm text-gray-500" data-id="element-725">{review.date}</span>
                  </div>
                  <div className="flex mb-3" data-id="element-726">{renderStars(review.rating)}</div>
                  <p className="text-gray-600" data-id="element-727">{review.text}</p>
                </div>)}
            </div>
            <div className="mt-6 text-center" data-id="element-728">
              <Button variant="outline" data-id="element-729">View All Reviews</Button>
            </div>
          </div>
        </div>
      </div>
    </section>;
}